// Created by hejikun on 2017/10/25 0025.
let state = {
  pdfURL: '',
  resultStatus: ''
}

const actions = {}

const getters = {}

const mutations = {
  set_pdfURL(state, arg) {
    state.pdfURL = arg
  },
  set_resultStatus(state, arg) {
    state.resultStatus = arg
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
